import React from "react"
import Video from "../../video/Video"
import Figure from "../figure"

const Body = () => {
  return (
    <Figure
      maxWidth="16em"
      maxWidthMobile="12em"
      caption={<>Candé’s uncle identified his nephew<br className="nm" /> at a morgue in Tripoli.</>}
    >
      <Video
        src="https://cdn.theoutlawocean.com/al-mabani/footage__aliou-candes-body-at-morgue.mp4"
        customPadding="166.67%"
        muted="muted"
        autoplay="autoplay"
      />
    </Figure>
  );
};
export default Body;
export { Body };